import { Expose } from "class-transformer";
import type { IProfileSectionDto } from "./profile-section.dto.interface";

export class ProfileSectionDto implements IProfileSectionDto {
  @Expose()
  id!: string;

  @Expose()
  isComplete!: boolean;

  @Expose()
  hasQuestionMark?: boolean;
}
